import { render, staticRenderFns } from "./ViewRenovations.vue?vue&type=template&id=99466f6e"
import script from "./ViewRenovations.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRenovations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports